import styled from 'styled-components';

export const Tbody = styled.tbody`
`;

export const Tr: any = styled.tr`
  height: 30px;
  background-color: ${(props: any) => props.color};
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #e0e0e0;

  :hover {
    background-color: rgba(0, 110, 255, 0.1);
  } 
`;

export const Td = styled.td`
  color: #333;
  font-family: Inter;
  padding-left: 8px;
  font-size: 12px;
`;
